
  import createMeisterIcons from '../src/createMeisterIcons';

  const Square9 = createMeisterIcons("square-9", [["path",{"fill":"currentColor","d":"M3.75 7c0-1.886 1.364-3.25 3.25-3.25h10A3.26 3.26 0 0 1 20.25 7v1.15H3.75zm0 8.654V17A3.26 3.26 0 0 0 7 20.25h4.25v-4.554zm0-1.5 7.5.042V9.65h-7.5zm9 1.55v4.546H17A3.26 3.26 0 0 0 20.25 17v-1.254zm7.5-1.458-7.5-.042V9.65h7.5zM7 2.25C4.286 2.25 2.25 4.286 2.25 7v10A4.76 4.76 0 0 0 7 21.75h10A4.76 4.76 0 0 0 21.75 17V7A4.76 4.76 0 0 0 17 2.25z","key":"7d924d198a0568e5fbda03dd74e5c0efbc53a3a0","fillRule":"evenodd","clipRule":"evenodd"}]])

  export default Square9
  